import React from "react";
import Body from "./components/page_one/Body";
import Home from "./components/page_one/Home";
import Navbar from "./components/page_one/Navbar";
import { LikeCountProvider } from "./components/page_one/BodyData/LikeNumbers";
import { CartCountProvider } from "./components/page_one/BodyData/CartNumbers";
import About from "./components/page_one/About";
import Brands from "./components/page_one/Brands";
import AppAdvertisement from "./components/page_one/AppAdvertisement";
import BeforeFooter from "./components/page_one/BeforeFooter";
import Footer from "./components/page_one/Footer";
import ContactDev from "./components/ContactDev";

function App() {
  return (
    <div className="App" style={{ overflowX: "hidden" }}>
      <header className="App-header">
        <LikeCountProvider>
          <CartCountProvider>
            <Navbar />
            <Home />
            <Body />
            <About />
            <Brands />
            <AppAdvertisement />
            <BeforeFooter />
            <Footer />
            <ContactDev/>
          </CartCountProvider>
        </LikeCountProvider>
      </header>
    </div>
  );
}

export default App;
